import { EReportStatus } from './report.types';

export enum ESortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export interface SearchReportsRequest {
  sortDirection?: ESortDirection;
  statuses?: EReportStatus[];
  createdAfter?: string;
  createdBefore?: string;
  limit?: number;
  page?: number;
}

export interface ReportSearchListItem {
  _id: string;
  reportId?: string;
  interval: { startDate: string; endDate: string };
  status: EReportStatus;
  publishers: string[];
  createdAt: string;
  updatedAt?: string;
  s3Key?: string;
  userId?: string;
  companyId?: string;
  reportAmount?: number;
  __v?: number;
}

export interface SearchReportsResponse {
  data: ReportSearchListItem[];
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
  total?: number;
}
